import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontWeight, Heading } from '@lili/lili-frontend-common';
import { LoginHelpOption } from '../../../../../flows/login/pages/LoginHelp/LoginHelpOption';
import { MfaType } from '../../../../../generic-components/MFA/types';

import { ReactComponent as PhoneCall } from '../../../../../assets/icons/svg/colored-icons/ic-colored-phone-call.svg';
import { ReactComponent as TextMessage } from '../../../../../assets/icons/svg/colored-icons/ic-colored-sms.svg';

interface InviteMFAResendProps {
  onMFAMethodClick: (mfaType: MfaType) => void;
}

export const InviteMFAResend = ({ onMFAMethodClick }: InviteMFAResendProps) => {
  const { t: inviteT } = useTranslation('inviteEN');

  return (
    <div className='flex flex-col justify-center px-[40px] py-[40px] rounded-lg bg-surface-primary-bw-00 fadeIn max-w-[436px]'>
      <Heading.H5 fontWeight={FontWeight.SEMIBOLD} className='text-text-main-primary mb-[16px] '>
        {inviteT('INVITE_MFA.RESEND_TITLE')}
      </Heading.H5>
      <LoginHelpOption
        title={inviteT('INVITE_MFA.MFA_METHOD.SMS')}
        icon={<TextMessage />}
        onClick={() => onMFAMethodClick(MfaType.SMS)}
        testId='mfa_method_sms'
        isSelected={false}
      />
      <LoginHelpOption
        title={inviteT('INVITE_MFA.MFA_METHOD.PHONE_CALL')}
        icon={<PhoneCall />}
        onClick={() => onMFAMethodClick(MfaType.VOICE)}
        testId='mfa_method_voice'
        isSelected={false}
      />
    </div>
  );
};
